module.exports = __webpack_public_path__ + "static/dashboard_screenshot_es-d87aa3f8eb7d0d532d97e76346f90b65.png";